/** Phase E (hlcity package): Hualien city, Dongdamen Night Market, Pine Garden and Ji'an. Lines marked “English practice” stay in English in every locale. */
export const enHlcity = {
  hlcity: {
    mapNames: { hlcity: 'Hualien City' },
    zones: {
      hcStation: 'Hualien Station',
      hcCreative: 'Cultural and Creative Park',
      hcPine: 'Pine Garden',
      hcMeilun: 'Meilun River',
      hcSnacks: 'Downtown snack street',
      hcIndigenous: 'Indigenous Street',
      hcMainland: 'Mainland Alley',
      hcDongdamen: 'Dongdamen Night Market',
      hcHotel: 'Seaview Hotel',
      hcBike: 'Coastal bike path',
      hcBeibin: 'Beibin Park',
      hcContainer: 'Container Coffee',
      hcQingxiu: 'Qingxiu Temple',
      hcPaddies: "Ji'an rice fields",
      hcJian: "Ji'an",
      hlcity: 'Hualien City',
    },
    objects: {
      hc_shuttle: 'Tourist Shuttle stop',
      hc_mural: 'Amis mural',
      hc_shrine: 'Earth God shrine',
      hc_marketMap: 'Night market map',
      hc_dumpling: 'Dumpling stall',
      hc_beefNoodle: 'Beef noodle stall',
      hc_xlb: 'Soup dumpling stall',
      hc_sausage: 'Grilled sausage stall',
      hc_bamboo: 'Bamboo-tube rice stall',
      hc_crafts: 'Amis handicrafts',
      hc_icecream: 'Peanut ice-cream roll',
      hc_tea: 'Bubble tea stall',
      hc_balloon: 'Balloon darts',
      hc_creative: 'Cultural Park board',
      hc_pineGarden: 'Pine Garden stone',
      hc_riverMouth: 'River mouth lookout',
      hc_bikePath: 'Bike path sign',
      hc_seafront: 'Seafront binoculars',
      hc_container: 'Container Coffee menu',
      hc_photo: 'Photo spot',
      hc_temple: 'Qingxiu Temple hall',
      hc_buddha88: 'The 88 Buddhas',
      hc_paddy: 'Rice field sign',
      hc_store: 'Good Neighbor store',
    },
    npc: {
      hc_stationStaff: 'Station staff',
      hc_taxiDriver: 'Taxi driver',
      hc_shuttleGuide: 'Shuttle guide',
      hc_dumplingGrandpa: 'Dumpling grandpa',
      hc_sausageVendor: 'Sausage uncle',
      hc_amisGrandma: 'Amis grandma',
      hc_balloonVendor: 'Game stall lady',
      hc_singer: 'Night market singer',
      hc_cyclist: 'Cyclist',
      hc_jogger: 'Jogger',
      hc_barista: 'Barista',
      hc_caretaker: 'Temple caretaker',
      hc_pineGuide: 'Pine Garden guide',
      hc_farmer: 'Rice farmer',
    },
    items: {} as Record<string, { name: string; desc: string }>,

    closed: 'The stall is covered with a tarp. Dongdamen Night Market opens at 5 p.m. — come back this evening!',
    stampHint: 'Your first bite at Dongdamen: a new passport stamp!',
    look: '👀 Just looking',
    back: '↩️ Back',

    // Food, ordered in English (vendor, ok and bad are English practice).
    food: {
      dumpling: { vendor: 'Pork dumplings, boiled fresh! Ten or twenty?', ok: 'Ten dumplings, please. With soy sauce.', bad: ['Dumplings. Hundred. Go.', 'I am a dumpling, please.'], done: 'Ten juicy dumplings, straight from the pot. Dip, blow, bite!', price: 40 },
      beefNoodle: { vendor: 'Beef noodle soup! Clear soup or red braised?', ok: 'Red braised, please. A small bowl.', bad: ['Noodle! Beef! Fast!', 'Cow soup for one cow.'], done: 'Soft beef, chewy noodles and a rich, dark soup. Grandpa learned the recipe from his father.', price: 60 },
      xlb: { vendor: 'Xiaolongbao! Soup inside — be careful, it’s hot!', ok: 'One basket, please. Thank you!', bad: ['Give me hot soup balls.', 'Basket. Now. Me.'], done: 'You bite a little hole, sip the soup, then eat the dumpling. Yum!', price: 50 },
      sausage: { vendor: 'Grilled pork sausage with garlic! Small or big?', ok: 'One small sausage, please.', bad: ['Sausage. Biggest. Free.', 'I want a sausage tree.'], done: 'Smoky, sweet and juicy — the sausage is grilled over charcoal. Indigenous Street’s favourite snack!', price: 30 },
      bamboo: { vendor: 'Bamboo-tube rice! Sticky rice cooked inside bamboo.', ok: 'Could I have one, please? It smells great!', bad: ['Bamboo. Eat. Me.', 'One panda, please.'], done: 'The uncle splits the bamboo open: the rice is sticky and smells of the forest. Amis families cook it for festivals.', price: 45 },
      crafts: { vendor: 'Handmade bracelets! Glass beads in many colours.', ok: 'Could I have the red one, please? It’s beautiful.', bad: ['Bracelet. Cheap. Now.', 'Give me all the beads.'], done: 'Grandma ties the bracelet on your wrist. “Red is for strength and happiness,” she says with a smile.', price: 20 },
      icecream: { vendor: 'Peanut ice-cream roll! With coriander or without?', ok: 'Without coriander, please. One roll.', bad: ['Ice cream. Wrap. Fast.', 'Coriander only, no ice cream.'], done: 'Shaved peanut brittle and two scoops of ice cream rolled in a thin pancake. Crunchy and cold!', price: 35 },
      tea: { vendor: 'Bubble tea! Sugar level and ice level?', ok: 'Half sugar, less ice, please.', bad: ['Tea. Bubbles. Max.', 'All the sugar in the world.'], done: 'Chewy tapioca pearls and creamy milk tea. Half sugar is just right!', price: 30 },
      container: { vendor: 'Welcome to Container Coffee! What would you like?', ok: 'Can I have a small hot chocolate, please?', bad: ['Chocolate. Hot. Give.', 'I want the whole container.'], done: 'A warm cup with a little wave drawn in the foam. You sip it looking at the stacked containers.', price: 30 },
      store: { vendor: 'Welcome! Hot tea eggs and baked sweet potatoes today.', ok: 'One tea egg, please. How much is it?', bad: ['Egg. Tea. Money no.', 'One store, please.'], done: 'The tea egg is brown and marbled, simmered in tea and spices. Every convenience store in Taiwan has a pot!', price: 12 },
    },

    // Landmarks.
    shuttle: 'The Taiwan Tourist Shuttle stops here: buses to Taroko Gorge and Qixingtan Beach.',
    mural: 'The station mural shows Amis patterns: red for strength, white diamonds, yellow for the sun. The Amis are the largest Indigenous people of Taiwan, and many live around Hualien.',
    muralQ: 'What do the Amis celebrate every summer?',
    muralA: ['The harvest festival', 'A snow festival', 'Halloween'],
    muralRight: 'Yes! The harvest festival (Ilisin): singing and dancing in a big circle to say thank you for the year.',
    muralWrong: 'Not quite. Look at the dancers holding hands in the mural…',
    shrine: 'A little shrine to the Earth God (土地公), who looks after the neighbourhood. Shopkeepers bring fruit and light incense in the morning.',
    shrineEn: 'Please keep our street safe.', // English practice
    pray: '🙏 Put your hands together',
    prayed: 'You bow three times. The incense smoke curls up into the sky.',
    marketMap: 'Dongdamen Night Market (東大門夜市): one huge market made from four old ones. Indigenous Street, Mainland Alley, Fuding and Ziqiang stalls, games and live music. Open every evening from 5 p.m. to midnight.',
    marketQ: 'When does the night market open?',
    marketA: ['At five p.m.', 'At five a.m.', 'At twelve noon'],
    marketRight: 'Right! At five p.m. the lights go on and the smoke from the grills fills the air.',
    marketWrong: 'Hmm, look at the opening hours on the map again.',
    balloon: 'Pop the balloons with darts! Five darts for 10 coins.',
    play: '🎯 Play (10 coins)',
    balloonQ: 'How many balloons did you pop?',
    balloonRight: 'Well counted! The lady gives you a little prize sticker.',
    balloonWrong: 'Count the 💥 again!',
    nums: ['zero', 'one', 'two', 'three', 'four', 'five'],
    popped: (n: string) => `I popped ${n} balloons!`, // English practice
    creative: 'This park was the Hualien Winery, built in the Japanese era about a hundred years ago. Today the old warehouses hold art shows, little shops and concerts.',
    creativeLook: '🏭 Peek into a warehouse',
    creativeDone: 'Inside: paintings by local artists, a little stage, and the smell of old wood and rice wine from long ago.',
    creativeEn: 'This used to be a winery. Now it is an art park.', // English practice
    pine: 'Pine Garden (松園別館), 1942: a white two-storey Japanese-era building with arcades, on a hill among Ryukyu pines more than a hundred years old. It was once an army office; today it is an art and poetry space with a view over the Meilun River and the Pacific.',
    pineQ: 'What kind of trees grow around the Pine Garden?',
    pineA: ['Pine trees', 'Palm trees', 'Apple trees'],
    pineRight: 'Yes — old Ryukyu pines, twisted by the sea wind.',
    pineWrong: 'Look at the name again: 松 means “pine”.',
    riverMouth: 'Here the Meilun River (美崙溪) meets the Pacific Ocean. Fishermen wait on the sandbar and egrets fish in the shallow water.',
    riverEn: 'The river meets the sea.', // English practice
    lookAround: '🔭 Look through the binoculars',
    lookedRiver: 'You can see the harbour, the river mouth and, far away, the green mountains dropping into the blue sea.',
    bikePath: 'The coastal bike path runs along the sea from the Meilun River to the south of the city. People ride, jog and walk their dogs here at sunrise.',
    bikeQ: 'What do you say when you pass someone on a bike?',
    bikeA: ['Excuse me, on your left!', 'Move, move!', 'Goodbye forever!'],
    bikeRight: 'Perfect — polite and clear. And ring your bell!',
    bikeWrong: 'That’s not very friendly. Try again!',
    seafront: 'Beibin Park looks out over the Pacific. On clear mornings the sun rises out of the sea, and sometimes you can spot fishing boats heading to the harbour.',
    seaEn: 'The sun rises over the Pacific Ocean.', // English practice
    listen: '🌊 Listen to the waves',
    listened: 'Shhh… whoosh… The pebbles roll back and forth with every wave.',
    photo: 'Container Coffee is built from 29 old shipping containers, stacked and sticking out like giant building blocks. Their glass ends let in the light.',
    photoHow: 'Ask a passer-by to take your photo. What do you say?',
    photoA: ['Could you take a photo of me, please?', 'Photo me. Now.', 'Take my camera away!'],
    photoRight: 'Click! A perfect photo with the colourful containers behind you.',
    photoWrong: 'Hmm, try a more polite way.',
    temple: 'Qingxiu Temple (慶修院) was built in 1917 by Japanese farmers who lived in Ji’an. Its wooden hall and stone lanterns make it one of the best-kept Japanese temples in Taiwan.',
    templeEn: 'This temple is more than one hundred years old.', // English practice
    wish: '🔔 Ring the bell and make a wish',
    wished: 'Gong… The deep sound rolls across the garden. You close your eyes and make a wish.',
    buddha: 'Along the path sit stone Buddha statues, one for each temple of a famous pilgrimage on the island of Shikoku, in Japan. Walking past all of them is like a tiny pilgrimage.',
    buddhaQ: 'How many stone Buddhas are there?',
    buddhaA: ['Eighty-eight', 'Eighteen', 'Eight hundred'],
    buddhaRight: 'Yes, 88! Four rows on each side of the path.',
    buddhaWrong: 'Count again: four rows of eleven on each side…',
    paddy: 'Ji’an’s rice fields are flooded with clear mountain water. Egrets walk between the rice plants looking for frogs and fish.',
    paddyQ: 'What do farmers grow in these fields?',
    paddyA: ['Rice', 'Ice', 'Rocks'],
    paddyRight: 'Right! Green in spring, golden in autumn.',
    paddyWrong: 'Look closely at the plants in the water…',
    singer: 'A singer with a guitar sings old Taiwanese songs and new pop hits. People clap along between the stalls.',
    clap: '👏 Clap along',
    clapped: 'Everybody sings the chorus together. The singer waves at you!',
    singerEn: 'Thank you, Hualien! One more song?', // English practice
    shuttleRide: '🚌 Take the shuttle',
    taxiEn: 'Could you take me to Dongdamen Night Market, please?', // English practice
    taxiQ: 'How do you ask the taxi driver politely?',
    taxiA: ['Could you take me to Dongdamen Night Market, please?', 'Dongdamen. Drive.', 'Where is my taxi going?'],
    taxiRight: '“Sure! Seat belt on, please.” — Next time you can just walk: it’s only ten minutes from here!',
    taxiWrong: 'A bit rude… try a polite question.',

    // People: player-language lines, plus one English phrase each (English practice).
    talk: {
      hc_stationStaff: {
        lines: ['Welcome to Hualien! The Taroko Express from Taipei takes about two hours.', 'Trains home leave from platform 1. Don’t miss the last one in the evening!', 'The station roof looks like the mountains, and the pillars wear Amis patterns.'],
        en: 'Welcome to Hualien! Enjoy your trip.', // English practice
      },
      hc_taxiDriver: {
        lines: ['Taxi? Hualien is small — the night market is ten minutes away.', 'I’ve driven a taxi here for twenty years. I know every noodle shop!', 'Tourists always ask me for Taroko. Take the shuttle bus — it’s cheaper!'],
        en: 'Where would you like to go?', // English practice
      },
      hc_shuttleGuide: {
        lines: ['The green shuttle bus goes to Taroko Gorge and Qixingtan Beach.', 'Have your coins ready, and sit on the right side for the sea view!', 'The last bus comes back before dark.'],
        en: 'Does this bus go to Taroko Gorge?', // English practice
      },
      hc_dumplingGrandpa: {
        lines: ['My father came from Shandong. These dumplings are his recipe.', 'This alley is called Mainland Alley: food from all over China.', 'Fold, pinch, pinch, pinch… I make five hundred dumplings a night!'],
        en: 'How many would you like?', // English practice
      },
      hc_sausageVendor: {
        lines: ['Welcome to Indigenous Street! Nga’ay ho — that means hello in Amis.', 'Bamboo rice, grilled sausage, millet cakes… all from the mountains and the sea.', 'Our grandparents taught us to share food with everybody.'],
        en: 'Nga’ay ho! Hello and welcome!', // English practice
      },
      hc_amisGrandma: {
        lines: ['I weave these bracelets by hand. Each colour has a meaning.', 'Red is strength, white is purity, yellow is the sun.', 'Our harvest festival is in summer. The whole village dances!'],
        en: 'Did you make this by hand?', // English practice
      },
      hc_balloonVendor: {
        lines: ['Five darts, ten coins! Pop three balloons and win a prize!', 'Aim in the middle, throw gently.', 'Kids are often better at this than their parents!'],
        en: 'Ready? Aim… throw!', // English practice
      },
      hc_singer: {
        lines: ['I sing here every night. Do you know any songs?', 'This one is an old Hualien love song.', 'Clap with me on the chorus!'],
        en: 'Thank you, Hualien! One more song?', // English practice
      },
      hc_cyclist: {
        lines: ['I ride the coastal path every morning. The sea is different every day.', 'From here you can ride all the way to the south of the city.', 'Wear a helmet and ring your bell!'],
        en: 'On your left!', // English practice
      },
      hc_jogger: {
        lines: ['Good morning! The river path is perfect for running.', 'I saw a heron by the river mouth today.', 'Run, breathe, smile!'],
        en: 'Good morning! Lovely day, isn’t it?', // English practice
      },
      hc_barista: {
        lines: ['Welcome to Container Coffee! Upstairs has the best view.', 'The containers stick out so the shade covers the terrace.', 'Our hot chocolate is the kids’ favourite.'],
        en: 'What size would you like: small, medium or large?', // English practice
      },
      hc_caretaker: {
        lines: ['I sweep the stone path every morning, past all 88 Buddhas.', 'Japanese farmers built this temple when this village was called Yoshino.', 'Walk quietly and bow a little at the hall.'],
        en: 'Please walk quietly in the temple.', // English practice
      },
      hc_pineGuide: {
        lines: ['These Ryukyu pines are more than a hundred years old.', 'From the balcony you can see the river meet the ocean.', 'Poets come here to write. Shall we read a poem?'],
        en: 'The view from the top is beautiful.', // English practice
      },
      hc_farmer: {
        lines: ['Ji’an rice grows with clean water from the Central Mountains.', 'The egrets are my helpers: they eat the bugs!', 'Two harvests a year: one in summer, one in autumn.'],
        en: 'The rice is green now. In autumn it turns gold.', // English practice
      },
    },
  },
};
